import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-short-term-hired-jobs')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/short-term-hired"
    infiniteScroll={true}
    message_if_none = 'No jobs that are short term hired..'
  />,
document.getElementById('react-component-g4-logistics-portal-short-term-hired-jobs'));
}
